import { createApp, ref } from "vue"
import { createRouter, createWebHistory } from "vue-router"

import RouterLink from "@peerdb/peerdb/components/RouterLink"
import { configKey } from "@peerdb/peerdb/config"
import siteContext from "@peerdb/peerdb/context"
import i18n from "@peerdb/peerdb/i18n"
import { progressKey } from "@peerdb/peerdb/progress"
import twMerge from "@peerdb/peerdb/tw-merge"

import "@/app.css"
import App from "@/App.vue"
import routes from "@peerdb/peerdb/routes"

// During development when requests are proxied to Vite, placeholders
// in HTML files are not rendered. So we set them here as well.
if (siteContext.title) {
  document.title = siteContext.title
}

const peerdbViews = import.meta.glob("/node_modules/@peerdb/peerdb/lib/views/*.vue.js")

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    // Search route handles its own scrolling through "at" query parameter.
    if (to.name === "SearchGet") {
      return false
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  routes: Object.entries(routes)
    .filter(([, route]) => route.handlers)
    .map(([name, route]) => ({
      path: route.path,
      name,
      component: peerdbViews[`/node_modules/@peerdb/peerdb/lib/views/${name}.vue.js`],
      props: true,
      strict: true,
    })),
})

const apiRouter = createRouter({
  history: createWebHistory(),
  routes: Object.entries(routes)
    .filter(([, route]) => route.api)
    .map(([name, route]) => ({
      path: route.path === "/" ? "/api" : `/api${route.path}`,
      name,
      component: () => null,
      props: true,
      strict: true,
    })),
})

router.apiResolve = apiRouter.resolve.bind(apiRouter)

const app = createApp(App).use(router)

// We replace Vue Router's RouterLink with ours.
delete app._context.components["RouterLink"]
app.component("RouterLink", RouterLink)

app
  .use(i18n)
  .use(twMerge)
  .provide(progressKey, ref(0))
  .provide(
    configKey,
    ref({
      fixedNavbar: false,
    }),
  )
  .mount("main")
